import { Component, OnDestroy, OnInit } from '@angular/core';
import { DataService, DateService, HelperService, HTTPService } from 'app/services';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AddDialogComponent } from '../add-dialog/add-dialog.component';
import { mileageUnits } from 'app/constants';
import { TransferVehicleDialogComponent } from '../transfer-vehicle-dialog/transfer-vehicle-dialog.component';
import { ConfirmDismissDialogComponent } from 'app/modules/shared/components';
import { find } from 'lodash';

@Component({
  selector: 'app-connect-motor-dialog',
  templateUrl: './connect-motor-dialog.component.html',
  styleUrls: ['./connect-motor-dialog.component.scss'],
})
export class ConnectToMotorDialogComponent implements OnInit {
  customer: any;
  vehicle: any;
  isProcessing = false;
  motor: any = {};
  currentCustomer: any = {};
  customerList: any = [];
  isDuplicateVehicle: boolean = false;
  openFrom = '';
  constructor(
    public addSuccessfullyDialog: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public dialogService: DialogService,
    private dataService: DataService,
    private httpService: HTTPService,
    public dateService: DateService,
    private helperService: HelperService,
    private dynamicDialogRef: DynamicDialogRef,
  ) { }

  ngOnInit() {
    const { customer, vehicle } = this.config.data;
    this.customer = customer;
    this.vehicle = vehicle;
  }

  handleSubmit() {
    this.isProcessing = true;
    const vehicle = this.vehicle;
    const data: any = {};
    // if (vehicle && vehicle.BaseVehicleID) {
    data.year = Number(vehicle.Year);
    data.make = vehicle.MakeName;
    data.model = `${vehicle.ModelName} ${vehicle.SubModelName || ''}`;
    data.engine = vehicle.EngineDescription;
    data.title = `${vehicle.Year} ${vehicle.MakeName} ${vehicle.ModelName} ${vehicle.SubModelName} ${vehicle.EngineDescription}`;
    data.name = `${data.year || ''} ${data.make || ''} ${data.model || ''}`;
    data.apiResponse = vehicle;
    data.customerId = this.customer._id;
    data.customerName = this.customer.fullName;
    data.isCarfaxConnected = true;
    data.licensePlateNo = vehicle.licensePlateNo
    data.VIN = vehicle.VIN;
    data.vin = data.VIN;

    this.httpService.updateMotorConnection(this.vehicle._id, data).then(
      (vehicle) => {
        if (!this.vehicle.isMotorConnected && vehicle.isMotorConnected) {
          this.helperService.showToaster('success', 'Vehicle was successfully linked');
        } else if (vehicle.isCarfaxConnected && !vehicle.isMotorConnected) {
          this.helperService.showToaster('error', 'Vehicle could not be connected to MOTOR. Please try searching for vehicle using another method (e.g. YMM)');
        } else {
          this.helperService.showToaster('success', `Vehicle was successfully ${vehicle.isMotorConnected ? 'updated' : 'disconnected'}`);
        }
        this.dataService.sendData(
          this.dataService.typeSidebar('close', null, null, {
            isSuccess: true,
            vehicle: { ...vehicle },
            type: 'ro-vehicle',
          })
        );
        this.handleCloseModal();
        this.isProcessing = false;

      },
      (err) => {
        this.isProcessing = false;
        if (this.dataService.isTransferVehicleEnabled) {
          this.currentCustomer = err.data.currentCustomer;
          if (err.data.customers) {
            err.data.customers.forEach((c) => {
              if (c.vehicles) {
                c.vehicles.map((v) => {
                  return (v.isChecked = false);
                });
              }
              this.customerList.push(c);
            });
            if (err.data.differentUser) {
              this.handleOpenTransferVehicleDialog();
            } else {
              if (this.customerList[this.customerList.length - 1].customerId === err.data.currentCustomer._id) {
                // this.vehicle.isTransferButtonEnabled = false;
                this.handleVehicleDuplication(err.data.customers[err.data.customers.length - 1].vehicles);
              }
            }
          }
        } else {
          this.helperService.showToaster('error', err);
        }
      }
    );
  };

  handleOpenTransferVehicleDialog() {
    const ref = this.dialogService.open(TransferVehicleDialogComponent, {
      width: '740px',
      styleClass: 'add-dialog transfer-vehicle-dialog',
      showHeader: false,
      data: {
        customerList: this.customerList,
        customerId: this.customer._id,
        vehicleName: `${this.vehicle.Year} ${this.vehicle.MakeName} ${this.vehicle.ModelName} ${this.vehicle.SubModelName} ${this.vehicle.EngineDescription}`,
        currentCustomer: this.currentCustomer,
        isShow: false,
        isMFConnected: true,
      },
    });

    const onClose = ref.onClose.subscribe((data) => {
      if (data.type === 'updateVehicle') {
        this.updateVehicleSidebar(data);
        this.handleCloseModal();
      }
      onClose.unsubscribe();
    });
  }

  handleVehicleDuplication(vehicleData) {
    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '30%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: {
        styleClassHeading: 'font-14',
        title: `Vehicle duplication`,
        message: `This vehicle cannot be created as a new vehicle because it already exists under this customer's name. However, you can proceed by updating the existing information for this vehicle`,
        button: {
          success: { title: 'Change & update', styleClass: 'btn-danger' },
          cancel: { title: 'Go back' },
        },
        headerIcon: 'fas fa-exclamation font-icon-red font-white',
      },
    });

    const onClose = ref.onClose.subscribe((close: any) => {
      if (close.isSuccess) {
        const data = { selectedVehicle: vehicleData[0] };
        this.updateVehicleSidebar(data);
        this.handleCloseModal();
      }
      onClose.unsubscribe();
    });
  }


  updateVehicleSidebar(data, isVehicleDuplicate = false) {
    if (data.selectedVehicle) {
      if (this.openFrom === 'quick-tire-lookup') {
        this.customer.fullName =
          data.selectedVehicle.customerName || data.selectedVehicle.currentCustomerName || this.customer.fullName;
        this.vehicle = {
          ODM: data.selectedVehicle.ODM,
          VIN: data.selectedVehicle.VIN,
          apiResponse: data.selectedVehicle.apiResponse,
          color: { name: data.selectedVehicle.color || '' },
          connectedVia: data.selectedVehicle.connectedVia,
          customerId: data.selectedVehicle.customerId,
          _id: data.selectedVehicle._id,
          driveType: { name: data.selectedVehicle.driveType || '' },
          engine: data.selectedVehicle.engine,
          isActive: true,
          isCarfaxConnected: data.selectedVehicle.isCarfaxConnected,
          isMotorAndCarfaxSynced: data.selectedVehicle.isMotorAndCarfaxSynced,
          isMotorConnected: data.selectedVehicle.isMotorConnected,
          licensePlateNo: data.selectedVehicle.licensePlateNo || '',
          make: data.selectedVehicle.make,
          model: data.selectedVehicle.model,
          name: data.selectedVehicle.name,
          notes: data.selectedVehicle.notes || '',
          odmHistory: data.selectedVehicle.odmHistory || [],
          registrationState: data.selectedVehicle.registrationState || '',
          registrationStateCode: data.selectedVehicle.registrationStateCode || '',
          tags: data.selectedVehicle.tags || [],
          vehicleCheck: data.selectedVehicle.vehicleCheck,
          vehicleName: data.selectedVehicle.vehicleName,
          vin: data.selectedVehicle.VIN,
          year: data.selectedVehicle.year,
          vehicleId: data.selectedVehicle._id,
          title: data.selectedVehicle.vehicleName,
          vehicle: data.selectedVehicle.vehicleName,
          fullName: data.selectedVehicle.customerName,
          type: 'vehicle-add',
        };
      } else {
        this.customer.fullName =
          data.selectedVehicle.customerName || data.selectedVehicle.currentCustomerName || this.customer.fullName;
        this.vehicle = {
          ODM: data.selectedVehicle.ODM,
          VIN: data.selectedVehicle.VIN,
          apiResponse: data.selectedVehicle.apiResponse,
          color: { name: data.selectedVehicle.color || '' },
          connectedVia: data.selectedVehicle.connectedVia,
          _id: data.selectedVehicle.customerId,
          driveType: { name: data.selectedVehicle.driveType || '' },
          engine: data.selectedVehicle.engine,
          isActive: true,
          isCarfaxConnected: data.selectedVehicle.isCarfaxConnected,
          isMotorAndCarfaxSynced: data.selectedVehicle.isMotorAndCarfaxSynced,
          isMotorConnected: data.selectedVehicle.isMotorConnected,
          licensePlateNo: data.selectedVehicle.licensePlateNo || '',
          make: data.selectedVehicle.make,
          model: data.selectedVehicle.model,
          name: data.selectedVehicle.name,
          notes: data.selectedVehicle.notes || '',
          odmHistory: data.selectedVehicle.odmHistory || [],
          registrationState: data.selectedVehicle.registrationState || '',
          registrationStateCode: data.selectedVehicle.registrationStateCode || '',
          tags: data.selectedVehicle.tags || [],
          vehicleCheck: data.selectedVehicle.vehicleCheck,
          vehicleName: data.selectedVehicle.vehicleName,
          vin: data.selectedVehicle.VIN,
          year: data.selectedVehicle.year,
          vehicleId: data.selectedVehicle._id,
          title: data.selectedVehicle.vehicleName,
          vehicle: data.selectedVehicle.vehicleName,
          fullName: this.customer.fullName,
          type: 'vehicle-add',
        };
      }

      if (data.selectedVehicle.transmission) {
        this.vehicle.transmission = { label: data.selectedVehicle.transmission === 'automatic' ? 'Automatic' : 'Manual', value: data.selectedVehicle.transmission || '' };
      }

      if (data.selectedVehicle.ODM && data.selectedVehicle.ODM.length) {
        let { reading, mileageMeasuringUnit } = data.selectedVehicle.ODM.pop();

        this.vehicle.mileage = `${reading || ''}`;

        if (reading) {
          // if (!mileageMeasuringUnit) {
          //   mileageMeasuringUnit = this.defaultMileageUnit;
          // }

          this.vehicle.mileageMeasuringUnit = find(mileageUnits, {
            value: mileageMeasuringUnit,
          });
        }
      }
    }
    this.isDuplicateVehicle = true;

    // if (this.openFrom === 'quick-tire-lookup') {
    //   this.onCustomerVehicleSelect(this.vehicle);
    //   this.isCreateVehicleMode = false;
    //   this.vehicleProcessingMode.emit(this.isCreateVehicleMode);
    // } else {
    // if (isVehicleDuplicate) {
    this.dataService.sendData(this.dataService.typePassData('vehicle-transfer', {}));
    // } else {
    // if (this.openFrom !== 'add-appointment') {
    // this.vehicleCreated.emit({
    //   customer: {
    //     _id: this.customer._id,
    //     fullName: this.customer.fullName,
    //   },
    //   vehicle: {
    //     _id: this.vehicle.vehicleId,
    //     name: this.vehicle.name,
    //     vehicle: {
    //       ...this.vehicle,
    //       _id: this.vehicle.vehicleId,
    //     },
    //   },
    //   openFrom: this.openFrom,
    // });
    // }
    // this.dataService.sendData(this.dataService.typePassData('vehicle-transfer', {}));
    // }

    this.dataService.sendData(
      this.dataService.typePassData('vehicle-list-customer-center', {
        vehicle: {
          vehicleId: data.selectedVehicle._id,
          name: data.selectedVehicle.name,
          vehicle: data.selectedVehicle || {},
        },
      })
    );

    this.dataService.sendData(this.dataService.typeSidebar('vehicle', this.vehicle._id, this.vehicle.fullName, this.vehicle));
    // this.openVehicleInSidePanel(this.vehicle);
  }


  handleCloseModal(data = {}): void {
    this.dynamicDialogRef.close(data);
  }

}
